import content from 'pp-react-l10n'
import FeaturesConfig from '../../../../config/features.json'
import enRTRStrings from '../../../../config/enRTRStrings'
import { PRODUCT_FLOWS } from '../../../../lib/constants'
let i18n = content('transfer/inc/currencyConversion')
let calcI18n = content('crossBorder/calc')

export function getDisclaimerMessage({
  convertWithPayPal,
  userCountry,
  convertUsingCard,
  isPurchase,
  isReview,
  isBetterRate,
  isFeeDisclaimerMessageDisabled,
}) {
  let feeDisclaimerMessage = i18n('info.fee')

  // with send money to friends abroad, we don't know the old fee since we load a seperate store, so we can't compare
  const isSendFriendsAbroadFlow = window.location.pathname.includes('fx/fees')

  if (!isReview && !isSendFriendsAbroadFlow) {
    feeDisclaimerMessage = (!isFeeDisclaimerMessageDisabled) ? i18n('info.lookForFee') : i18n('info.lookForFeeEEA')
  } else if (isBetterRate && !isSendFriendsAbroadFlow) {
    feeDisclaimerMessage = (!isFeeDisclaimerMessageDisabled) ? i18n('info.betterFee') : i18n('info.betterFeeEEA')
  } else if (isReview && isFeeDisclaimerMessageDisabled) {
    feeDisclaimerMessage = ''
  }

  // this is related to using PayPal's conversion rate, which includes paying with a bank card funding option.
  if (!convertWithPayPal) {
    // User choose card issuer to convert currency or no currency conversion is needed
    // Only show the disclaimer message if card is used to fund transaction and currency conversion need to happen
    const showDisclaimerMessage = convertUsingCard
    const cardIssuerMessage = i18n('options.newCreditCardExchangeRate')
    // Indicate to user that card issuer will determine the exchange rate if user choose using card issuer to convert currency
    feeDisclaimerMessage = showDisclaimerMessage ? cardIssuerMessage : ''
  }
  return feeDisclaimerMessage
}

export function getCurrencyCodeMessage(flow) {
  return flow === PRODUCT_FLOWS.SEND
    ? i18n('info.sendCurrencyCodeDisclaimer')
    : i18n('info.requestCurrencyCodeDisclaimer')
}

export function getDisclaimerMessageForRTRConfirmation({
  convertWithPayPal,
  userCountry,
  convertUsingCard,
  isPurchase,
}) {
  let feeDisclaimerMessage
  if (!convertUsingCard) {
    // for RTR confirmation and not converting with card case the disclaimer message is same as the message show on preview page
    return getDisclaimerMessage({
      convertWithPayPal,
      userCountry,
      convertUsingCard,
      isPurchase,
    })
  }

  const isNewDisclaimerMsg =
    userCountry &&
    FeaturesConfig[userCountry.toUpperCase()] &&
    FeaturesConfig[userCountry.toUpperCase()].isCFPBEnabled

  // for RTR case confirmation and converting currency USING card, the disclaimer message is different than the message show on preview page as funding option is not shown.
  if (convertWithPayPal) {
    if (isNewDisclaimerMsg) {
      feeDisclaimerMessage = i18n('info.simpleFeeDisclaimer')
    } else {
      feeDisclaimerMessage = isPurchase
        ? calcI18n('instructions.newForeignExchangeDisclaimer')
        : i18n('info.newFeeDisclaimer')
    }
  } else {
    feeDisclaimerMessage = ''
  }
  return feeDisclaimerMessage
}

export function getENDisclaimerMessage({
  convertWithPayPal,
  userCountry,
  convertUsingCard,
  isPurchase,
  isReview,
  isBetterRate,
}) {
  let feeDisclaimerMessage = enRTRStrings.infoFee

  // with send money to friends abroad, we don't know the old fee since we load a seperate store, so we can't compare
  const isSendFriendsAbroadFlow = window.location.pathname.includes('fx/fees')

  if (!isReview && !isSendFriendsAbroadFlow) {
    feeDisclaimerMessage = enRTRStrings.infoLookForFee
  } else if (isBetterRate && !isSendFriendsAbroadFlow) {
    feeDisclaimerMessage = enRTRStrings.infoBetterFee
  }

  // this is related to using PayPal's conversion rate, which includes paying with a bank card funding option.
  if (!convertWithPayPal) {
    // User choose card issuer to convert currency or no currency conversion is needed
    // Only show the disclaimer message if card is used to fund transaction and currency conversion need to happen
    const showDisclaimerMessage = convertUsingCard
    const cardIssuerMessage = enRTRStrings.optionsNewCreditCardExchangeRate
    // Indicate to user that card issuer will determine the exchange rate if user choose using card issuer to convert currency
    feeDisclaimerMessage = showDisclaimerMessage ? cardIssuerMessage : ''
  }
  return feeDisclaimerMessage
}

export function getENDisclaimerMessageForRTRConfirmation({
  convertWithPayPal,
  userCountry,
  convertUsingCard,
  isPurchase,
}) {
  let feeDisclaimerMessage
  if (!convertUsingCard) {
    // for RTR confirmation and not converting with card case the disclaimer message is same as the message show on preview page
    return getENDisclaimerMessage({
      convertWithPayPal,
      convertUsingCard,
    })
  }

  const isNewDisclaimerMsg =
    userCountry &&
    FeaturesConfig[userCountry.toUpperCase()] &&
    FeaturesConfig[userCountry.toUpperCase()].isCFPBEnabled

  // for RTR case confirmation and converting currency USING card, the disclaimer message is different than the message show on preview page as funding option is not shown.
  if (convertWithPayPal) {
    if (isNewDisclaimerMsg) {
      feeDisclaimerMessage = enRTRStrings.infoSimpleFeeDisclaimer
    } else {
      feeDisclaimerMessage = isPurchase
        ? enRTRStrings.instructionsNewForeignExchangeDisclaimer
        : enRTRStrings.infoNewFeeDisclaimer
    }
  } else {
    feeDisclaimerMessage = ''
  }
  return feeDisclaimerMessage
}
